const mobileMargin = 20
const mobileMaxWidth = 375
const desktopWidth = 500
const maxHeight = 700
const mobileTopOffset = 50
const mobileBottomMargin = 100
const mobileLeftMargin = 10

export const openWindowPopup = (url: string) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height

  const popupWidth = isMobile
    ? Math.min(screenWidth - mobileMargin, mobileMaxWidth)
    : desktopWidth
  const popupHeight = isMobile
    ? Math.min(screenHeight - mobileBottomMargin, maxHeight)
    : maxHeight
  const left = isMobile ? mobileLeftMargin : (screenWidth - popupWidth) / 2
  const top = isMobile ? mobileTopOffset : (screenHeight - popupHeight) / 2

  // Add mobile hints to URL (many OAuth providers recognize these)
  const urlSeparator = url.includes(`?`) ? `&` : `?`
  const mobileParams = [
    `display=popup`, // Common OAuth parameter
    `popup=1`, // Indicates popup context
    `mobile=1`, // Mobile device indicator
  ].join(`&`)

  url = `${url}${urlSeparator}${mobileParams}`

  const newWindow = window.open(
    url,
    `oauth-popup`, // custom name for the popup
    `width=${popupWidth},height=${popupHeight},left=${left},top=${top},scrollbars=yes,resizable=yes,toolbar=no,menubar=no,location=no,directories=no,status=no`,
  )

  if (!process.env.NATIVE_APP) {
    if (newWindow) {
      newWindow.focus() /** @see https://developer.mozilla.org/en-US/docs/Web/API/Window/focus */
    } else {
      /**
       * @todo Implement user feedback for blocked popups
       */
      // When "newWindow" is falsy, it means that the browser blocked the popup
    }
  }

  return newWindow
}
